import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { array } from 'prop-types';

function Favicon({
  links
}) {
  return links.map((linkProps, key) => /*#__PURE__*/React.createElement("link", _extends({
    key: `link-head-${key}`
  }, linkProps)));
}

Favicon.defaultProps = {
  links: []
};
process.env.NODE_ENV !== "production" ? Favicon.propTypes = {
  links: array
} : void 0;
export default Favicon;